module.exports = __webpack_public_path__ + "static/media/blackpen.d254be14.svg";